module.exports = __webpack_public_path__ + "images/q2-otro-color-img.jpg";